import React from 'react';
import styles from './Legal.module.css';
import { useNavigate } from 'react-router-dom';

const Legal = ({ propertyId }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.certificatesContainer}>
        <div className={styles.certificateCard}>
          <h3 className={styles.certificateTitle}><span>Legal Corner</span></h3>
          <button 
            className={styles.viewAllButton}
            onClick={() => navigate(`/properties/${propertyId}/legal-documents`)}
          >
            View
          </button>
        </div>
    </div>
  );
};

export default Legal;